module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "content login-wrapper"
  }, [_c('div', {
    staticClass: "content-inner loginBox"
  }, [_c('div', {
    staticClass: "flex-column full-w centered"
  }, [_c('div', {
    staticClass: "min-width-300 max-width-300"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/kundan-logo.png"),
      "width": "150px"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('static.resetPassword.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.resetPassword.firstParagraph')))]), _vm._v(" "), _c('v-form', {
    attrs: {
      "save": _vm.send,
      "form": _vm.form,
      "btn-text": "button.send",
      "translation": "form.resetPassword"
    }
  })], 1)])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14120a9e","hasScoped":false}!./src/app/pages/auth/resetPassword/resetPassword.html
// module id = 2920
// module chunks = 1